import { type FC, type ReactNode } from "react";
import { Link } from "../Link";
import { type Tag } from "~/foundation/SitecoreContent/generated-types";
import { useSitecoreContext, type ItemReference } from "~/foundation/Jss";
import { type SimpleTag } from "./types";

type TagLinkProps = {
	tag: (ItemReference<Tag> | SimpleTag);
	children: ReactNode;
}

const TagLink: FC<TagLinkProps> = ({ tag, children }) => {
	const { sitecoreContext } = useSitecoreContext();
	const tagLinks = sitecoreContext?.custom?.tagUrls;

	function getTagLink(tag: ItemReference<Tag> | SimpleTag) {
		if (!tag.id) {
			return null;
		}

		if (tagLinks) {
			const tagLink = tagLinks[tag.id];
			if (tagLink) {
				return tagLink;
			}
		}
		return null;
	}

	const tagLink = getTagLink(tag);

	// don't render anything if tagLink is not available
	if (!tagLink) {
		return null;
	}

	// no link wrapper, no span automatically added
	// we can use this to render the tag as a link
	// and wrap the spans with this component
	return (
		<Link to={tagLink} noWrapper>
			{children}
		</Link>
	);
};

export default TagLink;